import { NavLink } from 'react-router-dom';
import { Home, Info, Dumbbell, HelpCircle, MessageSquare } from 'lucide-react';

const tabs = [
  { to: '/', icon: Home, label: 'Home' },
  { to: '/about', icon: Info, label: 'About' },
  { to: '/services', icon: Dumbbell, label: 'Train' },
  { to: '/faq', icon: HelpCircle, label: 'FAQ' },
  { to: '/contact', icon: MessageSquare, label: 'Contact' },
];

export default function MobileBottomNav() {
  return (
    <nav className="fixed bottom-0 inset-x-0 z-50 bg-background-secondary/90 backdrop-blur-lg border-t border-white/10 safe-area-bottom">
      <div className="flex justify-around items-center h-16">
        {tabs.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 text-[10px] font-medium transition-colors ${
                isActive ? 'text-primary-light' : 'text-gray-400'
              }`
            }
          >
            <Icon className="w-5 h-5" />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
